import * as yup from 'yup';

export const SimpleUpdateLogbookConf = {
  schema: yup.object({
    id_supplier: yup.object().nullable().required('Supplier is required'),
  }),
  defaultValues: {
    id_supplier: null,
  },
  fields: [
    {
      id: 'logbook_divider',
      type: 'divider',
      label: 'Add Items in Logbook',
      xs: 12,
    },
    {
      id: 'id_supplier',
      name: 'id_supplier',
      type: 'autocomplete',
      label: 'Supplier',
      options: [],
      required: true,
      xs: 12,
    },
  ],
};
